import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import {
	Tabs,
	Tab,
	Box,
	Button,
	Dialog,
	DialogTitle,
	DialogContent,
	TextField,
	DialogActions,
	Menu,
	MenuItem,
	IconButton,
} from '@mui/material'
import KanbanBoard from '../components/request/KanbanBoard' // Импортируем дочерний компонент
import { observer } from 'mobx-react-lite'
import requestStore from '../stores/requestStore' // Импортируем store
import { FiMoreVertical, FiEdit } from 'react-icons/fi'
import { FaRegTrashCan } from 'react-icons/fa6'
import { IoMdArrowBack } from 'react-icons/io'
import { IoMdArrowForward } from 'react-icons/io'
import { RiArchiveDrawerLine } from 'react-icons/ri'
import '../index.css'
import logger from '../utils/logger'
import BoardDeletionDialog from '../components/request/BoardDeletionDialog'
import { canManageStructure } from '../tenancy/resourcePermissions'
import RequestDetailDialog from '../components/request/RequestDetailDialog'

const RequestsPage = observer(() => {
	const [searchParams, setSearchParams] = useSearchParams()
	const [deepLinkedRequest, setDeepLinkedRequest] = useState(null)
	const [selectedBoardIndex, setSelectedBoardIndex] = useState(0)
	const [newBoardName, setNewBoardName] = useState('')
	const [isDialogOpen, setDialogOpen] = useState(false)
	const [renamedBoardName, setRenamedBoardName] = useState('')
	const [selectedBoardForMenu, setSelectedBoardForMenu] = useState(null)
	const [isRenameDialogOpen, setRenameDialogOpen] = useState(false)
	const [isDeleteDialogOpen, setDeleteDialogOpen] = useState(false)
	const [anchorEl, setAnchorEl] = useState(null)
	const [deletionPlan, setDeletionPlan] = useState(null)
	const [migrationDialogOpen, setMigrationDialogOpen] = useState(false)
	const [openArchived, setOpenArchived] = useState(false)

	// Сортируем доски по полю sort
	const sortedBoards = requestStore.requests
		.slice()
		.sort((a, b) => a.sort - b.sort)
	useEffect(() => {
		const requestId = searchParams.get('requestId')
		if (!requestId) {
			setDeepLinkedRequest(null)
			return
		}
		const boardIndex = sortedBoards.findIndex(board => board.columns?.some(column => column.requests?.some(request => String(request.id || request.requestId) === requestId)))
		if (boardIndex >= 0) {
			setSelectedBoardIndex(boardIndex)
			const linked = sortedBoards[boardIndex].columns
				.flatMap(column => column.requests || [])
				.find(request => String(request.id || request.requestId) === requestId)
			setDeepLinkedRequest(current => String(current?.id || current?.requestId) === requestId ? current : linked)
		}
	}, [searchParams, sortedBoards])

	const closeDeepLink = () => {
		const next = new URLSearchParams(searchParams)
		next.delete('requestId')
		setSearchParams(next, { replace: true })
		setDeepLinkedRequest(null)
	}

	const handleChange = (event, newValue) => {
		setSelectedBoardIndex(newValue)
	}

	const handleMenuClose = () => {
		setAnchorEl(null)
	}

	const handleRenameBoard = () => {
		logger.log('Переименовать доску:', selectedBoardForMenu)
		setRenamedBoardName(selectedBoardForMenu?.name || '')
		setRenameDialogOpen(true)
		handleMenuClose() // Закрываем меню
	}

	// загружать, если ничего не загружено
	useEffect(() => {
		// Загружаем данные только при первой загрузке
		if (requestStore.requests.length === 0) {
			logger.log('На досках пусто, надо делать запрос')
			requestStore.fetchRequests('requests-page')

			/* requestStore.fetchFOfromObjectPage() */
		}
	}, [])

	const handleBoardToLeft = () => {
		handleMenuClose() // Сначала закрываем меню
		setTimeout(() => {
			requestStore.moveBoard(selectedBoardForMenu.boardId, 'left').then(() => {
				const updatedSortedBoards = requestStore.requests
					.slice()
					.sort((a, b) => a.sort - b.sort)
				const newIndex = updatedSortedBoards.findIndex(
					board => board.boardId === selectedBoardForMenu.boardId
				)
				setSelectedBoardIndex(newIndex)
			})
		}, 100) // Небольшая задержка перед выполнением действия
	}

	const handleBoardToRight = () => {
		handleMenuClose() // Сначала закрываем меню
		setTimeout(() => {
			requestStore.moveBoard(selectedBoardForMenu.boardId, 'right').then(() => {
				const updatedSortedBoards = requestStore.requests
					.slice()
					.sort((a, b) => a.sort - b.sort)
				const newIndex = updatedSortedBoards.findIndex(
					board => board.boardId === selectedBoardForMenu.boardId
				)
				setSelectedBoardIndex(newIndex)
			})
		}, 100) // Небольшая задержка перед выполнением действия
	}

	const handleMenuClick = (event, board) => {
		setAnchorEl(event.currentTarget)
		setSelectedBoardForMenu(board)
	}

	const handleDeleteBoard = () => {
		setDeleteDialogOpen(true)
		handleMenuClose() // Закрываем меню
	}

	const selectedBoard = sortedBoards[selectedBoardIndex]

	const handleAddBoard = () => {
		requestStore.addBoard(newBoardName).then(() => {
			setDialogOpen(false)
			setNewBoardName('')
		})
	}
	// Нажали «ОК» в диалоге подтверждения удаления
	const confirmDeleteBoard = async () => {
		if (selectedBoardForMenu) {
			logger.log(
				'Удаляем доску ID:',
				selectedBoardForMenu.boardId,
				'Название:',
				selectedBoardForMenu.boardName
			)
			const result = await requestStore.deleteBoard(selectedBoardForMenu.boardId)
			if (result?.plan) {
				setDeletionPlan(result.plan)
				setMigrationDialogOpen(true)
			}
		}
		setDeleteDialogOpen(false)
	}

	const confirmRenameBoard = () => {
		if (selectedBoardForMenu) {
			logger.log(
				'Переименовываем доску ID:',
				selectedBoardForMenu.boardId,
				'Новое название:',
				renamedBoardName
			)
			requestStore.renameBoard(selectedBoardForMenu.boardId, renamedBoardName)
		}
		setRenameDialogOpen(false)
	}

	const cancelRenameBoard = () => {
		setRenameDialogOpen(false)
	}

	// Нажали «Отмена» в диалоге подтверждения
	const cancelDeleteBoard = () => {
		setDeleteDialogOpen(false)
	}

	return (
		<div className='ml-5 flex flex-col h-[calc(100vh-64px)]'>
			<Box sx={{ borderBottom: 1, borderColor: 'divider', flexShrink: 0, pt: 0.75 }}>
				<div className='flex flex-row items-center min-w-0'>
					<Tabs
						value={selectedBoardIndex}
						onChange={handleChange}
						aria-label='Доски заявок'
						role='tablist'
						variant='scrollable'
						scrollButtons
						allowScrollButtonsMobile
						sx={{ flexGrow: 1, minWidth: 0, '& .MuiTabs-flexContainer': { gap: 0.5 } }}
					>
						{sortedBoards.map((board, index) => (
							<Tab
								key={board.boardId}
								label={
									<Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
										<span>{board.name}</span>
										{selectedBoard?.boardId === board.boardId && canManageStructure(board) && (
											<IconButton
												size='small'
												onClick={e => {
													e.stopPropagation();
													handleMenuClick(e, board);
												}}
												sx={{ padding: '4px' }}
												data-board-id={board.boardId}
											>
												<FiMoreVertical fontSize="small"/>
											</IconButton>
										)}
									</Box>
								}
								id={`tab-${index}`}
								role='tab'
								aria-selected={selectedBoardIndex === index}
								aria-controls={`tabpanel-${index}`}
								sx={(theme) => ({
									minHeight: 36,
									minWidth: 0,
									px: 1.5,
									py: 0.5,
									border: '1px solid transparent',
									borderRadius: 1,
									color: theme.vars?.reldo?.color?.textSecondary ?? theme.palette.text.secondary,
									'&:hover': { bgcolor: theme.vars?.reldo?.color?.hover ?? theme.palette.action.hover },
									'&.Mui-selected': {
										color: theme.vars?.reldo?.color?.text ?? theme.palette.text.primary,
										bgcolor: theme.vars?.reldo?.color?.selected ?? theme.palette.action.selected,
										borderColor: theme.vars?.reldo?.color?.borderStrong ?? theme.palette.divider,
										borderBottomLeftRadius: 0,
										borderBottomRightRadius: 0,
									},
								})}
							/>
						))}
					</Tabs>
					<Button
						size='small'
						variant='text'
						color='inherit'
						onClick={() => setOpenArchived(true)}
						sx={{ ml: 1, flexShrink: 0, color: 'text.secondary', '&:hover': { bgcolor: 'action.hover', color: 'text.primary' } }}
					>
						<RiArchiveDrawerLine style={{ marginRight: 6 }} />
						Архив
					</Button>
					<Button onClick={() => setDialogOpen(true)} sx={{ ml: 0.5, mr: 1, flexShrink: 0 }}>
						+ доска
					</Button>
				</div>
			</Box>

			<Box sx={{ flexGrow: 1, overflow: 'hidden', position: 'relative' }}>
				{sortedBoards.map((board, index) => (
					<div
						key={board.boardId}
						role='tabpanel'
						hidden={selectedBoardIndex !== index}
						id={`tabpanel-${index}`}
						aria-labelledby={`tab-${index}`}
						style={{ height: '100%' }}
					>
						{selectedBoardIndex === index && (
							<KanbanBoard boardId={board.boardId} openArchived={openArchived} onCloseArchived={() => setOpenArchived(false)} />
						)}
					</div>
				))}
			</Box>

			<Dialog open={isDialogOpen} onClose={() => setDialogOpen(false)}>
				<DialogTitle>Создать новую доску</DialogTitle>
				<DialogContent>
					<TextField
						autoFocus
						margin='dense'
						label='Название доски'
						fullWidth
						value={newBoardName}
						onChange={e => setNewBoardName(e.target.value)}
					/>
				</DialogContent>
				<DialogActions>
					<Button onClick={() => setDialogOpen(false)}>Отмена</Button>
					<Button onClick={handleAddBoard} disabled={!newBoardName.trim()}>
						Создать
					</Button>
				</DialogActions>
			</Dialog>

			<Menu
				anchorEl={anchorEl}
				open={Boolean(anchorEl)}
				onClose={handleMenuClose}
			>
				<MenuItem onClick={handleRenameBoard}>
					<FiEdit style={{ marginRight: '10px' }} /> Переименовать
				</MenuItem>
				<MenuItem onClick={handleBoardToLeft}>
					<IoMdArrowBack style={{ marginRight: '10px' }} /> Доску влево
				</MenuItem>
				<MenuItem onClick={handleBoardToRight}>
					<IoMdArrowForward style={{ marginRight: '10px' }} /> Доску вправо
				</MenuItem>
				<MenuItem onClick={handleDeleteBoard}>
					<FaRegTrashCan style={{ marginRight: '10px', color: '#CC0000' }} />
					Удалить доску
				</MenuItem>
			</Menu>
			<Dialog open={isDeleteDialogOpen} onClose={cancelDeleteBoard}>
				<DialogTitle>Подтверждение удаления</DialogTitle>
				<DialogContent>
					Вы уверены, что хотите удалить доску{' '}
					<strong>{selectedBoardForMenu?.boardName}</strong>?
				</DialogContent>
				<DialogActions>
					<Button onClick={cancelDeleteBoard}>Отмена</Button>
					<Button onClick={confirmDeleteBoard} color='error'>
						Удалить
					</Button>
				</DialogActions>
			</Dialog>
			<Dialog open={isRenameDialogOpen} onClose={cancelRenameBoard}>
				<DialogTitle>Переименовать доску</DialogTitle>
				<DialogContent>
					<TextField
						autoFocus
						margin='dense'
						label='Новое название доски'
						fullWidth
						value={renamedBoardName}
						onChange={e => setRenamedBoardName(e.target.value)}
					/>
				</DialogContent>
				<DialogActions>
					<Button onClick={cancelRenameBoard}>Отмена</Button>
					<Button
						onClick={confirmRenameBoard}
						disabled={!renamedBoardName.trim()}
					>
						Переименовать
					</Button>
				</DialogActions>
			</Dialog>
			<BoardDeletionDialog
				open={migrationDialogOpen}
				board={selectedBoardForMenu}
				initialPlan={deletionPlan}
				onClose={() => setMigrationDialogOpen(false)}
				onDeleted={() => {
					setMigrationDialogOpen(false)
					setDeletionPlan(null)
					setSelectedBoardIndex(0)
				}}
			/>
			<RequestDetailDialog open={Boolean(deepLinkedRequest)} request={deepLinkedRequest} onClose={closeDeepLink} />
		</div>
	)
})

export default RequestsPage
